// extracted by mini-css-extract-plugin
export default {"SimpleList__Content":"simple-list_SimpleList__Content__cKwxh"};